/**
 * Term-komponent for "sikker eksamensnettleser (SEB)".
 *
 * Nå en tynn wrapper rundt InlineHelpTerm som leser innholdet fra databasen
 * (slug: wizard-seb-browser). Innhold forvaltes via /settings/help-articles —
 * oppdateringer slår umiddelbart gjennom i hele veiviseren uten kode-deploy.
 */
import InlineHelpTerm from './InlineHelpTerm';

interface SebTermProps {
  /** Bruk 'short' for "sikker eksamensnettleser (SEB)" (default), 'bare' for kun "SEB" */
  variant?: 'short' | 'bare';
}

export default function SebTerm({ variant = 'short' }: SebTermProps) {
  const label = variant === 'bare' ? 'SEB' : 'sikker eksamensnettleser (SEB)';
  return <InlineHelpTerm slug="wizard-seb-browser" label={label} route="/courses-and-exams" />;
}
